// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"875202f9","93":"6ceb9b9e","142":"ce9083d7","162":"6ed4930d","178":"6cc3decc","266":"1c838684","461":"dba089dc","605":"e6c681bf","714":"051d75f3","716":"a58e585e","783":"bb359ec8","846":"61405950","958":"dd115116"}[chunkId] + ".chunk.js";
};